/* import __COLOCATED_TEMPLATE__ from './user-info.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { alias } from "@ember/object/computed";
import { prioritizeNameInUx } from "discourse/lib/settings";
import { userPath } from "discourse/lib/url";
import discourseComputed from "discourse-common/utils/decorators";
import TEMPLATE from "./user-info.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  classNameBindings: [":user-info", "size"],
  attributeBindings: ["data-username"],
  size: "small",
  "data-username": alias("user.username"),
  includeLink: true,
  includeAvatar: true,
  didInsertElement() {
    this._super(...arguments);
    this.user?.statusManager?.trackStatus();
  },
  willDestroyElement() {
    this._super(...arguments);
    this.user?.statusManager?.stopTrackingStatus();
  },
  userPath(username) {
    return userPath(username);
  },
  nameFirst(name) {
    return prioritizeNameInUx(name);
  }
}, [["method", "userPath", [discourseComputed("user.username")]], ["method", "nameFirst", [discourseComputed("user.name")]]])));